import DataExportAuditTrailTemplate from '../../components/5templates/DataExportAuditTrailTemplate'
import {useState} from 'react'
import dayjs from 'dayjs'
import {downloadCsvData} from '../../services/util/miscellaneousService'
import ApiService from '../../common/ApiCalls'
import {formatDateInSelectedFormat} from '../../services/util/formatter'

const DataExportAuditTrail = () => {
    const now = dayjs()
    const today = formatDateInSelectedFormat(now.$d, 'YYYY-MM-DD')

    const [isErrorSnackbarOpen, setIsErrorSnackbarOpen] = useState(false)

    const [dataType, setDataType] = useState('')
    const handleDataTypeChange = (newValue) => {
        setDataType(newValue)
    }

    const [fromDate, setFromDate] = useState(today)
    const onFromDateChange = (date) => {
        const fromDateFormatted = formatDateInSelectedFormat(date.$d, 'YYYY-MM-DD')
        setFromDate(fromDateFormatted)
    }

    const [toDate, setToDate] = useState(today)
    const onToDateChange = (date) => {
        const toDateFormatted = formatDateInSelectedFormat(date.$d, 'YYYY-MM-DD')
        setToDate(toDateFormatted)
    }

    const getDataChangeLog = async () => {
        return downloadCsvData(()=>ApiService().getDataChangeLogs(fromDate, toDate),
            setIsErrorSnackbarOpen, 'data_change_log')
    }

    const getUserActivityLog = async () => {
        return downloadCsvData(()=>ApiService().getUserActivityLogs(fromDate, toDate),
            setIsErrorSnackbarOpen, 'user_activity_log')
    }

    const handleExport = () => {
        switch(dataType){
            case 'Data Change Log':
                return getDataChangeLog()
            case 'User Activity Log':
                return getUserActivityLog()
            default:
                console.log('There was an error')
        }
    }

    const disabled = (step) => {
        switch (step) {
            case 0:
                return dataType === ''
            default:
                return false
        }
    }

    return (
        <DataExportAuditTrailTemplate dataType={dataType} onDataTypeChange={handleDataTypeChange}
                                      fromDate={fromDate} setFromDate={onFromDateChange} toDate={toDate}
                                      setToDate={onToDateChange} handleExport={handleExport} disabled={disabled}
                                      isErrorSnackbarOpen={isErrorSnackbarOpen} setIsErrorSnackbarOpen={setIsErrorSnackbarOpen}/>
    )
}

export default DataExportAuditTrail
